<template>
  <div v-loading="loading">
    <el-table
      v-if="tableConfig"
      :key="tableKey"
      :data="manufacturers.data"
      style="width: 100%"
      row-key="id"
      @sort-change="handleSortChange"
    >
      <component
        :is="column.value"
        v-for="column in tableConfig.columns"
        :key="column.value"
      />
      <el-table-column
        fixed="right"
        label=""
        width="130"
        style="text-align: right;"
      >
        <template
          slot="header"
          slot-scope="scope"
        >
          <table-settings
            v-if="tableConfig"
            :config="tableConfig"
            :allcolumns="allColumns"
            :labels="labels"
            storeModule="manufacturer"
            :options="['settings']"
          />
        </template>
        <template
          slot-scope="scope"
        >
          <Actions :manufacturer="scope.row"/>
        </template>
      </el-table-column>
    </el-table>
    <div class="el-card-footer">
      <el-pagination
        background
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-sizes="[20, 50, 100, 200]"
        :page-size="manufacturers.per_page"
        layout="total, prev, pager, next"
        :total="manufacturers.total"
      />
    </div>
  </div>
</template>

<script>
  import Actions from './Actions';
  import TableSettings from '../../../TableSettings';
  import columns, { allColumns, labels } from './columns';

  export default {
    components: {
      Actions,
      TableSettings,
      ...columns,
    },
    data() {
      return {
        labels,
        allColumns,
        tableKey: 0,
        currentPage: 1,
        currentSort: {
          prop: 'name',
          order: 'ascending',
        },
      };
    },
    computed: {
      manufacturers() {
        return this.$store.getters['manufacturer/manufacturers'];
      },
      tableConfig() {
        return JSON.parse(JSON.stringify(this.$store.getters['manufacturer/tableConfig']));
      },
      loading() {
        return this.$store.getters['manufacturer/loading'];
      },
    },
    watch: {
      tableConfig() {
        this.tableKey++;
      },
    },
    methods: {
      handleCurrentChange(val) {
        this.$store.commit('manufacturer/setCurrentPage', val);
        this.$store.dispatch('manufacturer/fetchAllWithPagination');
      },
      handleSortChange({ column, prop, order }) {
        this.$store.commit('manufacturer/setSorting', { prop, order });
        this.$store.dispatch('manufacturer/fetchAllWithPagination');
      },
    },
    async mounted() {
      this.$store.commit('manufacturer/setCurrentPage', this.currentPage);
      this.$store.commit('manufacturer/setSorting', this.currentSort);
      await this.$store.dispatch('manufacturer/fetchAllWithPagination');
    },
  };
</script>

